// TermsConditions.js
import React from 'react';
import './TermsConditions.css';
import TopBar from '../../components/topbar/TopBar.js';
// import privacyPolicy from '../PrivacyPolicy/PrivacyPolicy.js'; 


const TermsConditions = () => {
    return (
        <div className="TermsConditions">
            <TopBar />
            <div className="TermsConditions-content">
                <h1 className="TermsConditions-title">Terms of Use</h1>
                {/* <p className="TermsConditions-paragraph">
                    <strong>Effective Date:</strong> [Insert Date]
                </p> */}
                <p className="TermsConditions-paragraph">
                    Welcome to Myt. By using our app, you agree to the following Terms of Use and our 
                    <a href="/privacypolicy" target="_blank" rel="noopener noreferrer"> Privacy Policy</a>. 
                    If you do not agree, please do not use the app.
                </p>

                <h3>1. Eligibility</h3>
                <p className="TermsConditions-paragraph">
                    You must be at least 18 years old to use Myt. By using the app, you confirm that you meet this age requirement.
                </p>

                <h3>2. User Conduct and Content</h3>
                <p className="TermsConditions-paragraph">
                    You are responsible for any content you create, upload, or share on Myt. Do not post content that is offensive, harmful, or illegal. 
                    Violations may result in content removal or account suspension.
                </p>

                <h3>3. Community Guidelines</h3>
                <p className="TermsConditions-paragraph">
                    Treat all users with respect. Do not impersonate others, create fake profiles, or engage in harassment, scams, or spam.
                </p>

                <h3>4. Reporting and Moderation</h3>
                <p className="TermsConditions-paragraph">
                    Users can report inappropriate content or block other users. Myt reviews all reports within 24 hours and takes necessary action.
                </p>

                <h3>5. Account Termination</h3>
                <p className="TermsConditions-paragraph">
                    We may suspend or terminate your account for violations of these Terms.
                </p>

                <h3>6. Privacy</h3>
                <p className="TermsConditions-paragraph">
                    Your data is handled according to our 
                    <a href="/privacypolicy" target="_blank" rel="noopener noreferrer"> Privacy Policy</a>.
                </p>

                <h3>7. Modifications</h3>
                <p className="TermsConditions-paragraph">
                    We may update these Terms at any time. Continued use means you accept the updated terms.
                </p>

                <h3>8. Contact</h3>
              <p className="TermsConditions-paragraph">
    If you have questions or wish to report violations, please use our 
    <a href="/contactus" target="_blank" rel="noopener noreferrer"> Contact Us</a> page.
</p>
            </div>
        </div>
    );
};

export default TermsConditions;
